var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosedSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98094 5.06017H8.35368V3.78572C8.35368 2.02699 6.9486 0.599609 5.21735 0.599609C3.48609 0.599609 2.08102 2.02699 2.08102 3.78572V5.06017H1.45375C0.763758 5.06017 0.199219 5.63367 0.199219 6.33461V12.7068C0.199219 13.4078 0.763758 13.9813 1.45375 13.9813H8.98094C9.67094 13.9813 10.2355 13.4078 10.2355 12.7068V6.33461C10.2355 5.63367 9.67094 5.06017 8.98094 5.06017ZM5.21781 10.7954C4.52782 10.7954 3.96328 10.2219 3.96328 9.52093C3.96328 8.81998 4.52782 8.24648 5.21781 8.24648C5.90781 8.24648 6.47235 8.81998 6.47235 9.52093C6.47235 10.2219 5.90781 10.7954 5.21781 10.7954ZM3.33516 3.78628V5.06072H7.09875V3.78628C7.09875 2.72849 6.25822 1.87461 5.21695 1.87461C4.17569 1.87461 3.33516 2.72849 3.33516 3.78628Z",
    fill: "#E4AB10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosedSmall);
export default __webpack_public_path__ + "static/media/lock-closed-small.499dc41b374b0c29d9b1e70a99ed01f5.svg";
export { ForwardRef as ReactComponent };